import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import { BackdropWrapper, DateRequestInfoWrapper, RequestWrapper } from './DateRequests.styles'
import MobileHeader from '../../../components/MobileHeader/MobileHeader'
import { routes } from '../../../utils/constants'
import { useFetchScoreboardQuery } from '../../../services/api'
import { LoadingSkeleton } from './DateRequestInfo'
import Text from '../../../components/Text'
import { colors, PageWrapper } from '../../../styles/_var'
import { useSetHeaderTitle } from '../../../hooks/hooks'
import Container from '@mui/material/Container'
import { ActivityBackDrop } from '../PlanActivity/CreateActivity/CreateActivity.styles'
import Paper from '@mui/material/Paper'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'
import { UserInfo } from '../../../components/UserInfo/UserInfo'
import { getUserByUsername } from '../../../utils/helpers'

const ScoreboardPage = () => {
  const { date_id } = useParams()
  const navigate = useNavigate()
  const { data, isLoading, isError } = useFetchScoreboardQuery({ id: date_id || '' })
  useSetHeaderTitle(data?.date_request.activity || 'Scoreboard', true)

  if (!date_id) return null

  const errorView = (
    <Box mt={2} p={3} display="flex" justifyContent="center">
      <Text color={colors.danger}>Failed to load scoreboard</Text>
    </Box>
  )

  const loading = (
    <Box mt={2} p={3}>
      <LoadingSkeleton />
    </Box>
  )

  if (!data && isLoading) return loading
  if (!data && isError) return errorView

  return (
    <RequestWrapper>
      <MobileHeader onNavigateBack={() => navigate(routes.DASHBOARD)} />
      <PageWrapper>
        <BackdropWrapper>
          <ActivityBackDrop backdrop={data?.date_request.backdrop_image} />
        </BackdropWrapper>
        <Container><Box mt={5} /></Container>
        <DateRequestInfoWrapper>
          <Container>
            <Paper sx={{marginBottom: 3}}>
              <Box p={2}>
                <Text useDiv inline variant="medium" weight="bold" mb={1}>
                  {data?.date_request.activity}.
                </Text>
                {!!data?.date_request.description && <Text italic>{data?.date_request.description}</Text>}
              </Box>
            </Paper>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell><Text weight="semibold">Player</Text></TableCell>
                    <TableCell><Text weight="semibold">Games</Text></TableCell>
                    <TableCell><Text weight="semibold">Wins</Text></TableCell>
                    <TableCell><Text weight="semibold">Points</Text></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.scoreboard.map(([username, scoreboardData], index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Text center>{index + 1}</Text>
                      </TableCell>
                      <TableCell>
                        <UserInfo 
                          onlyShowName
                          onlyFirstName
                          useSmallAvatar
                          titleTextVariant='regular'
                          user={getUserByUsername(username, data?.date_request.date_participants || [])}
                        />
                      </TableCell>
                      <TableCell><Text ml={2}>{data?.total_weeks}</Text></TableCell>
                      <TableCell>
                        <Text ml={2}>{scoreboardData.wins}</Text>
                      </TableCell>
                      <TableCell>
                        <Text ml={2}>{scoreboardData.points}</Text>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Container>
        </DateRequestInfoWrapper>
      </PageWrapper>
    </RequestWrapper>
  )
}

export default ScoreboardPage

